export default __webpack_public_path__ + "static/media/ravens_tile_cover.48056c64.png";